import { Pressable, StyleSheet, Text, View } from 'react-native'
import { useSession } from '../auth'
import { colors, fontFamily } from '../tokens'

type Props = {
  onHome: () => void
  onAuth: () => void
  onAccount: () => void
}

export const AppHeader = ({ onHome, onAuth, onAccount }: Props) => {
  const session = useSession()
  const user = session.data?.user
  return (
    <View style={styles.bar}>
      <Pressable accessibilityRole="button" onPress={onHome} style={styles.wordmark}>
        <View style={styles.glyph}>
          <Text style={styles.glyphText}>≡</Text>
        </View>
        <Text style={styles.logo}>
          <Text style={styles.logoBold}>Band</Text>
          <Text style={styles.logoLight}>check</Text>
        </Text>
      </Pressable>
      <View style={styles.right}>
        {user ? (
          <Pressable accessibilityRole="button" onPress={onAccount} style={styles.action}>
            <Text style={styles.actionText}>{user.email}</Text>
          </Pressable>
        ) : (
          <Pressable accessibilityRole="button" onPress={onAuth} style={styles.action}>
            <Text style={styles.actionText}>Sign in</Text>
          </Pressable>
        )}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    height: 72,
    backgroundColor: colors.bg,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  wordmark: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 9,
  },
  glyph: {
    width: 30,
    height: 30,
    borderRadius: 9,
    backgroundColor: colors.primary[700],
    alignItems: 'center',
    justifyContent: 'center',
  },
  glyphText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '800',
    lineHeight: 18,
  },
  logo: {
    fontSize: 19,
    letterSpacing: -0.4,
    color: colors.ink,
    fontFamily: fontFamily.body,
  },
  logoBold: { fontWeight: '800' },
  logoLight: { fontWeight: '600', color: colors.muted },
  right: { flexDirection: 'row', gap: 12 },
  action: { paddingHorizontal: 8, paddingVertical: 4 },
  actionText: {
    color: colors.primary[700],
    fontWeight: '600',
    fontSize: 14,
    fontFamily: fontFamily.body,
  },
})
